/**
 * 전체 폭 상단 표시줄 (통합표준 6절). 로고 + 시스템명만 보여준다.
 *
 * ★ 사용자 정보·로그아웃은 항상 왼쪽 사이드바 하단에만 둔다(.sidebar-user,
 *   Sidebar.tsx). 예전에는 iframe(ONE 통합) 안에서 사이드바가 숨겨질 때 여기로
 *   대신 보여주는 자리를 뒀지만, 상단에도 사용자 정보가 뜬다는 피드백을 받아
 *   없앴다 — iframe 안에서는 ONE 쉘 자체의 계정·로그아웃을 쓰면 된다.
 */
export function Navbar() {
  return (
    <nav className="app-navbar">
      <div className="navbar-brand">
        <span className="navbar-brand__logo" aria-hidden="true">
          SC
        </span>
        <span>StoreCAD</span>
        <span className="navbar-brand__sub">Layout Studio</span>
      </div>
    </nav>
  );
}
